import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { EmbeddedService } from '@shared/services/embedded.service';

/**
 * Permite acceso solo en modo embedded.
 * Si no es embedded, redirige a la ruta raíz (start-process).
 */
export const embeddedGuard: CanActivateFn = () => {
  const embedded = inject(EmbeddedService);
  const router = inject(Router);

  if (embedded.isEmbedded()) {
    return true;
  }

  return router.createUrlTree(['']);
};
